// extracted by mini-css-extract-plugin
export default {"queryButton":"hjJU0 DeJoR uSVJz","queryButtonText":"iMHUT AfLf3"};